import { createContext } from 'react';

export interface ToastProps {
  title?: string;
  description: string;
  variant?: 'default' | 'destructive';
  duration?: number;
}

export interface ToastContextType {
  toast: (props: ToastProps) => void;
}

export const ToastContext = createContext<ToastContextType | undefined>(undefined);
